import React, { useState } from 'react';
import PropTypes from 'prop-types';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout/GeneralDialogLayout';
import Input from '@Components/Input';
import Button from '@Components/Button';
import { SingleSelect } from '@els/els-react--select';
import GSFNSubstances from '../GSFNSubstances';

import './GSFNDialog.scss';

const GSFNDialog = ({ options, onInputEnter, substances, onSubstanceSelect, ...otherProps }) => {
  const [inputValue, setInputValue] = useState('');
  const selectOption = options[0]?.value || '';
  const [option, setOption] = useState(options[0]);
  const MIN_QUERY_LENGTH = 3;

  const inputEnterHandler = () => {
    inputValue && inputValue.length >= MIN_QUERY_LENGTH && onInputEnter(inputValue, option);
  };

  return (
    <GeneralDialogLayout
      {...otherProps}
      movable={false}
      className="react-dialogs-scrollable insert-structure-from-name-dialog"
      header={<h4>Create structure template from name</h4>}>
      <div className="insert-structure-from-name-dialog__content">
        <div className="insert-structure-from-name-dialog__content__options">
          <SingleSelect
            label="Select option"
            shouldHideLabel
            options={options}
            optionsFlyoutProps={{
              noInternalPadding: true,
              theme: 'default',
              placement: 'bottom',
              pointer: true,
              pointerType: 'primary',
            }}
            selectedOptions={[selectOption]}
            onSelect={setOption}
            className="insert-structure-from-name-dialog__content__options__select"
            required
          />
        </div>
        <div className="insert-structure-from-name-dialog__content__search">
          <Input
            classNameInput="insert-structure-from-name-dialog__content__search__input"
            animatedPlaceholder
            onChange={setInputValue}
            value={inputValue}
            placeholder="Enter a chemical name, CAS-RN, InChiKey or SMILES"
            clearButton={false}
            debounceDelay={0}
            autofocus
            inputProps={{
              onKeyPress: (e) => {
                e.key === 'Enter' && inputEnterHandler();
              },
            }}
          />
          <Button
            onClick={inputEnterHandler}
            buttonConfig={{
              type: 'link',
              size: 'lg',
              iconOnly: true,
              ariaLabel: 'Search',
              className: 'insert-structure-from-name-dialog__content__search__button',
              e2eName: 'insert-structure-from-name-search',
            }}
            iconConfig={{
              className: 'insert-structure-from-name-dialog__content__search__icon',
              name: 'search',
              size: 'lg',
            }}
          />
        </div>
      </div>
      {substances && <GSFNSubstances substances={substances} onSubstanceSelect={onSubstanceSelect} />}
    </GeneralDialogLayout>
  );
};

GSFNDialog.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      isDisabled: PropTypes.bool,
    })
  ).isRequired,
  onInputEnter: PropTypes.func.isRequired,
  substances: PropTypes.array,
  onSubstanceSelect: PropTypes.func.isRequired,
};

export const typeOfGSFNDialog = 'typeOfGSFNDialog';
export default GSFNDialog;
